import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import Badge from '../Badge';
import SuccessoIcon from '../Icons/SuccessoIcon';
import ErroreIcon from '../Icons/ErroreIcon';
import State from './State';

const renderIcon = (icon, index, state) => {
  if (icon) {
    return icon;
  }
  if (state === State.DONE) {
    return <SuccessoIcon />;
  }
  if (state === State.ERROR) {
    return <ErroreIcon />;
  }
  if (state === State.ACTIVE) {
    return <Badge info>{index}</Badge>;
  }

  return <Badge>{index}</Badge>;
};

const StepItem = ({
  className, index, optional,
  state, onClick, title, icon, subTitle,
}) => {
  const stepClasses = cns(
    'stepper__step',
    {
      'stepper__step--active': state === State.ACTIVE,
      'stepper__step--todo': state === State.TODO,
      'stepper__step--done': state === State.DONE,
      'stepper__step--error': state === State.ERROR,
    },
    className,
  );

  const intestazioneClasses = cns(
    'stepper__stepIntestazione',
    {
      'stepper__stepIntestazione--selectable': !!onClick,
    },
    className,
  );

  return (
    <div
      className={stepClasses}
      key={index}
    >
      <div
        className={intestazioneClasses}
        onClick={() => { onClick && onClick(index); }}
        role="presentation"
      >
        {renderIcon(icon, index, state)}
        <div className="stepper__step__infoes">
          <span className="stepper__stepName">{title}</span>
          {subTitle && <span className="stepper__step--sottoTitolo">{subTitle}</span>}
          {optional && <span className="stepper__step--facoltativo">Opzionale</span>}
          {state === State.ERROR && <span className="stepper__step--errore">Errore</span>}
        </div>
      </div>
    </div>
  );
};

StepItem.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Icona da impostare per lo step */
  icon: PropTypes.node,
  /** Indice dello step */
  index: PropTypes.number,
  /**
   * Callback invocata al click dello step:
   * ```
   *  onClick(index)
   * ```
   * dove:
   * * *index*: indice dello step selezionato
   */
  onClick: PropTypes.func,
  /** Indica se lo step è opzionale */
  optional: PropTypes.bool,
  /** Indica lo stato dello Step, può assumere
     * i seguenti valori: ACTIVE: 0, DONE: 1, TODO: 2, ERROR: 3 */
  state: PropTypes.number.isRequired,
  /** Il titolo dello step */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  /** sottotitolo opzionale */
  subTitle: PropTypes.string,
};

StepItem.defaultProps = {
  className: '',
  icon: null,
  index: 0,
  onClick: null,
  optional: false,
  subTitle: null,
};

export default StepItem;
